"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sort = sort;
exports.sortWith = sortWith;
exports.compareJoin = compareJoin;
exports.compareAsc = compareAsc;
exports.compareDesc = compareDesc;
exports.compareKeyAsc = compareKeyAsc;
exports.compareKeyDesc = compareKeyDesc;
const objectOperations_1 = require("./objectOperations");
const ramda_1 = require("ramda");
/**
 * Sorts the given array without mutation
 * @param array
 * @param compareFn Function used to determine the order of the elements. It is expected to return a negative value if the first argument is less than the second argument, zero if they're equal, and a positive value otherwise. If omitted, the elements are sorted in ascending, ASCII character order.
 * @returns
 */
function sort(array, compareFn) {
    const arrayCopy = (0, objectOperations_1.deepCopy)(array);
    return arrayCopy.sort(compareFn);
}
function sortWith(array, compareFns) {
    return (0, ramda_1.sortWith)(compareFns, array);
}
/**
 * Combines multiple compare functions into one compare function, each acting as a tie breaker for the last
 * @param compareFns
 */
function compareJoin(compareFns) {
    return (a, b) => {
        for (const compareFn of compareFns) {
            if (compareFn(a, b) === 0) {
                continue;
            }
            return compareFn(a, b);
        }
        return 0;
    };
}
/**
 * Makes an ascending comparator function out of a function that returns a value that can be compared with < and >.
 * @param fn
 * @returns
 */
function compareAsc(fn) {
    return (a, b) => {
        const aa = fn(a);
        const bb = fn(b);
        return aa < bb ? -1 : aa > bb ? 1 : 0;
    };
}
/**
 * Makes a descending comparator function out of a function that returns a value that can be compared with < and >.
 * @param fn
 * @returns
 */
function compareDesc(fn) {
    return (a, b) => {
        const aa = fn(a);
        const bb = fn(b);
        return aa < bb ? 1 : aa > bb ? -1 : 0;
    };
}
/**
 *
 * @param key
 * @returns an ascending comparator function given an object key
 */
function compareKeyAsc(key) {
    return compareAsc((0, objectOperations_1.valueOf)(key));
}
/**
 *
 * @param key
 * @returns a descending comparator function given an object key
 */
function compareKeyDesc(key) {
    return compareDesc((0, objectOperations_1.valueOf)(key));
}
